import { render, staticRenderFns } from "./HomeNewsDetails.vue?vue&type=template&id=03c25f46&"
import script from "./HomeNewsDetails.vue?vue&type=script&lang=js&"
export * from "./HomeNewsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports